import { Outlet, useLocation } from 'react-router-dom'
import { IPVPSidebar } from '../components/Sidebar'
import { OrganizationSidebarContent } from '../components/OrganizationSidebar'

export default function AuthenticatedLayout() {
  const location = useLocation()

  // Check if current route is organization route
  const isOrganizationRoute = location.pathname.startsWith('/organization')

  // Determine active item based on current pathname
  const getActiveItem = (pathname: string) => {
    if (pathname.startsWith('/dashboard')) return 'dashboard'
    if (pathname.startsWith('/assessment')) return 'assessment'
    if (pathname.startsWith('/results')) return 'results'
    if (pathname.startsWith('/learning-path')) return 'learning-path'
    if (pathname.startsWith('/settings')) return 'settings'
    return 'dashboard' // default
  }

  const activeItem = getActiveItem(location.pathname)

  return (
    <div className='flex h-screen bg-[#EDEFF3]'>
      {/* Sidebar - Conditional based on route */}
      {isOrganizationRoute ? (
        <aside className='hidden lg:block w-[300px] border-r border-gray-200 bg-white'>
          <OrganizationSidebarContent />
        </aside>
      ) : (
        <IPVPSidebar activeItem={activeItem} />
      )}

      {/* Main Content */}
      <div className='flex-1 flex flex-col overflow-hidden'>
        <main className='flex-1 overflow-y-auto'>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
